<template>
  <li>
    <dl class="purchaseDate">
      <dt class="accessibilityHide">{{ title }}</dt>
      <dd>{{ date }}</dd>
    </dl>
    <router-link :to="toPath" class="btDetail">
      상세보기
      <span class="icon iconMore4"></span>
    </router-link>
    <ul class="listTypeCart">
      <li class="productItem" v-for="(item, index) in calList" :key="index">
        <list-item :product="item" :shopName="propsdata.shopName"></list-item>
      </li>
    </ul>
    <button v-if="isMore" type="button" class="btMore" @click="limit = false">
      <span class="icon iconMore"></span>
      더보기
    </button>
  </li>
</template>

<script>
import ListItem from '@/views/my/ListItem'

export default {
  name: 'WrapListItem',
  components: {
    ListItem
  },
  props: {
    propsdata: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      limit: true
    }
  },
  computed: {
    isPathNameCancel() {
      return this.$route.name === 'cancel'
    },
    date() {
      if (this.propsdata.withdrawDate) return this.propsdata.withdrawDate

      return this.propsdata.purchaseDate.substring(0, 10)
    },
    title() {
      return `${this.isPathNameCancel ? '청약철회' : '구매'} 일시`
    },
    toPath() {
      return {
        name: `${this.$route.name}View`,
        params: {
          purchaseId: this.isPathNameCancel
            ? this.propsdata.purchaseProductId
            : this.propsdata.purchaseId
        }
      }
    },
    list() {
      return this.isPathNameCancel
        ? [this.propsdata]
        : this.propsdata.purchaseProductList
    },
    calList() {
      return this.limit ? this.list.slice(0, 5) : this.list
    },
    isMore() {
      return this.list.length > this.calList.length
    }
  }
}
</script>

<style lang="scss"></style>
